import { fromClass } from "fw-model";

export class AtsOrganizationMappingMetaData {
    AtsOrganizationId: string;
    AtsSeasonId: string;
    HasPendingChanges: boolean;
    ErrorSyncing: boolean;
    CurrentSyncTaskId: string;
    CurrentSyncHistoryId: string;
    DateLastSyncedUtc: string;
}

export class AtsOrganizationMapping {
    Id: string;
    @fromClass MetaData: AtsOrganizationMappingMetaData;
}

export enum AtsOrganizationSyncHistoryStatus {
    InProgress = 0,
    Complete = 1,
    Error = 2
}

export function getStatusName(index: AtsOrganizationSyncHistoryStatus): string {
    switch (index) {
        case AtsOrganizationSyncHistoryStatus.InProgress:
            return "In-Progress";
        case AtsOrganizationSyncHistoryStatus.Complete:
            return "Completed";
        case AtsOrganizationSyncHistoryStatus.Error:
            return "Error";
        default:
            return "Unknown";
    }
}

export class AtsOrganizationSyncHistoryMetaData {
    AtsOrganizationId: string;
    AtsSeasonId: string;
    AtsOrganizationMappingId: string;
    DateCreatedUtc: string;
    DateUpdatedUtc: string;
    TaskRequestId: string;
    TaskRequestStatus: string;
    TaskRequestDateUpdatedUtc: string;
    Status: AtsOrganizationSyncHistoryStatus;
    StatusUpdates: string[];
    TotalActions: number;
    CompletedActions: number;
    ErroredActions: number;
}

export class AtsOrganizationSyncHistory {
    Id: string;
    @fromClass MetaData: AtsOrganizationSyncHistoryMetaData;
}
